import { FC } from 'react';
import cn from 'classnames';
import { ElementThemeUnion } from 'constants/routes';
import { ReactComponent as ChevronDown } from 'images/newIcons/chevron-down.svg';

import MultiSelectValue from './MultiSelectValue';

interface MultiSelectBaseProps {
  value: string[];
  onToggle: () => void;
  showOptions: boolean;
  placeholder: string;

  endIcon?: React.ReactNode;
  selectedCount?: number;
  theme?: ElementThemeUnion;
}

const MultiSelectBase: FC<MultiSelectBaseProps> = ({
  value,
  onToggle,
  showOptions,
  placeholder,
  endIcon,
  selectedCount,
  theme = 'light',
}) => {
  const backgroundClass = theme === 'light' ? 'bg-light' : 'bg-dark';

  return (
    <div
      className={cn(
        'flex items-center justify-between h-10 px-4 rounded-md cursor-pointer',
        backgroundClass
      )}
      onClick={onToggle}
    >
      <div className="flex items-center justify-between w-full">
        <MultiSelectValue
          value={value}
          showOptions={showOptions}
          placeholder={placeholder}
          selectedCount={selectedCount}
          endIcon={endIcon}
        />
      </div>
      <ChevronDown
        className={cn(
          'transform transition-transform duration-200 icon-container',
          {
            'rotate-180': showOptions,
            'rotate-0': !showOptions,
          }
        )}
      />
    </div>
  );
};

export default MultiSelectBase;
